<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
// Auth layout for authentication pages
</script> 